import { AlertTriangle, RotateCw } from 'lucide-react'
import { errorMessage } from '@/lib/api'
import { Button } from './ui/button'

export function QueryError({ error, onRetry, className }: { error: unknown; onRetry?: () => void; className?: string }) {
  return (
    <div role="alert" className={className}>
      <div className="flex flex-col items-center gap-3 px-6 py-12 text-center">
        <div className="flex size-11 items-center justify-center rounded-full bg-danger/10 text-danger">
          <AlertTriangle className="size-5" />
        </div>
        <div className="space-y-1">
          <p className="font-medium">Couldn’t load this data</p>
          <p className="max-w-sm text-sm text-muted-foreground">{errorMessage(error)}</p>
        </div>
        {onRetry && (
          <Button variant="outline" size="sm" onClick={onRetry}>
            <RotateCw /> Try again
          </Button>
        )}
      </div>
    </div>
  )
}
